var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPromotion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_5916)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_850_5916",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_850_5916)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_850_5916",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_850_5916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.21502 1.28577C4.59226 1.02391 5.04662 0.896524 5.50502 0.924107C5.56063 0.923205 5.61626 0.925152 5.67168 0.92994C6.00142 0.934846 6.3265 1.00853 6.62612 1.14629C6.92574 1.28405 7.1933 1.48284 7.41168 1.72994C7.98501 2.44827 8.84502 3.72411 9.43668 4.61911L9.29335 4.63994C8.06835 4.82827 5.79335 5.17827 4.87668 4.48411C4.56353 4.27216 4.2999 3.99502 4.10385 3.67168C3.9078 3.34834 3.78397 2.98644 3.74085 2.61077C3.71976 2.37044 3.75034 2.12838 3.83055 1.90085C3.91075 1.67332 4.03872 1.46559 4.20585 1.29161L4.21502 1.28577Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8842 1.28662C16.0517 1.46032 16.1799 1.66801 16.2602 1.89562C16.3404 2.12322 16.3707 2.36542 16.3492 2.60578C16.3063 2.98153 16.1826 3.34353 15.9865 3.66691C15.7904 3.99029 15.5267 4.26738 15.2133 4.47912C14.2917 5.17328 12.02 4.82328 10.7967 4.63495L10.6533 4.61412C11.2442 3.71412 12.105 2.44245 12.6792 1.72495C12.8972 1.47767 13.1646 1.27875 13.4641 1.14097C13.7636 1.0032 14.0887 0.929614 14.4183 0.924951C14.4751 0.920046 14.5321 0.918099 14.5892 0.919118C15.0476 0.89147 15.5019 1.01886 15.8792 1.28078L15.8842 1.28662Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.850931 9.25242V6.25242C0.850931 6.14633 0.893074 6.04459 0.968088 5.96957C1.0431 5.89456 1.14484 5.85242 1.25093 5.85242H9.6276V9.65242H1.5501V9.70825C1.45408 9.67199 1.35269 9.652 1.2501 9.64908C1.14401 9.64908 1.04227 9.60694 0.967255 9.53193C0.89224 9.45691 0.850098 9.35517 0.850098 9.24908L0.850931 9.25242Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19336 10.72H9.62586V19.085H2.76336C2.68971 19.085 2.61678 19.0705 2.54874 19.0423C2.48069 19.0141 2.41887 18.9728 2.36679 18.9207C2.31471 18.8686 2.2734 18.8068 2.24522 18.7388C2.21703 18.6707 2.20253 18.5978 2.20253 18.5241L2.19336 10.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6509 19.085V10.72H17.81V18.52C17.81 18.6689 17.7509 18.8118 17.6455 18.9171C17.5402 19.0225 17.3973 19.0816 17.2484 19.0816L10.6509 19.085Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1509 9.25331C19.1509 9.3594 19.1087 9.46114 19.0337 9.53616C18.9587 9.61117 18.857 9.65331 18.7509 9.65331C18.6482 9.65603 18.5467 9.67632 18.4509 9.71331V9.65498H10.6509V5.85498H18.7509C18.857 5.85498 18.9587 5.89712 19.0337 5.97214C19.1087 6.04715 19.1509 6.14889 19.1509 6.25498V9.25331Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_5916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPromotion);
export default __webpack_public_path__ + "static/media/icon-promotion.3bf634883252cb800030a0ce137b3591.svg";
export { ForwardRef as ReactComponent };